import Vue from 'vue'
let actions = {
  quickLinks (context) {
    context.commit('addLog', { request: 'quickLinks' })
    var quicklinksarr = window.location.href.split('/')
    var host = quicklinksarr[0] + '//' + quicklinksarr[1] + quicklinksarr[2]
    Vue.axios.get(host + '/static/data/quickLinks.json', {
      withCredentials: true,
      xsrfCookieName: 'SSO_TOKEN'
    }).then((response) => {
      context.commit('setQuickLinks', response.data)
      context.commit('removeLog', { request: 'quickLinks' })
    }).catch(() => {
      context.commit('removeLog', { request: 'quickLinks' })
    })
  }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/quickLinks/actions.js